import ICaminhao from 'modules/caminhao/domain/entities/Caminhao'
import { ICaminhaoRepository } from '../repositories/ICaminhaoRepository'

export interface IActiveOrInactive {
  execute(caminhao: ICaminhao): Promise<void>
}

export default class ActiveOrInactiveImpl implements IActiveOrInactive {
  constructor(private readonly caminhaoRepository: ICaminhaoRepository) {}

  public async execute(caminhao: ICaminhao): Promise<void> {
    await this.caminhaoRepository.activeOrInactive(caminhao)
  }
}
